import React from 'react'

import * as Layouts from 'layouts'

const Blocks = ({ data, index }) => {
  const BlockName = data.__typename.replace('WpPage_Pagebuilder_Layouts_', '')

  const Default = () => (
    <div className="container my-6">
      <div className="bg-red-100 py-8 text-red-700 border-l-4 px-4 border-red-500 rounded text-center">
        Warning: In AllLayouts the mapping of this component is missing:{' '}
        <strong>{data.__typename}</strong>
      </div>
    </div>
  )

  const BlockLayout = Layouts[BlockName] ? Layouts[BlockName] : Default

  return <BlockLayout {...data} />
}

export default Blocks
